<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="tighteningSpecification_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Tightening Specification -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.TIGHTENING_SPECIFICATION' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #tighteningSpecification_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.TIGHTENING_SPECIFICATION' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <div class="row">
        <div class="col-md-8 lubricant-type-drop">
            <ng-container>
                <mat-select
                    formControlName="tighteningSpecification"
                    name="tightening_specification"
                    class="mat-select-general input-form-class"
                    [class.spinner]="loading"
                    [class.select-disable]="enable"
                >
                    <!-- <mat-option *ngIf="!isEngineeredJoint" value="Informate Recommended">Informate Recommended</mat-option> -->
                    <mat-option class="option-list" *ngFor="let tsl of tightningSpecList1" [value]="tsl.key">{{ tsl.name }}</mat-option>
                    <ng-container *ngIf="tightningSpecList2?.length">
                        <hr />
                        <mat-option class="option-list" *ngFor="let tsl2 of tightningSpecList2" [value]="tsl2.key">{{ tsl2.name }}</mat-option>
                    </ng-container>
                </mat-select>
            </ng-container>
        </div>
        <div class="col-md-4">
            <ng-container>
                <input
                    matInput
                    *ngIf="istighteningSpecOverideInput"
                    formControlName="tighteningSpecOveride"
                    class="input-form-class mat-input-number"
                    #tooltip="matTooltip"
                    matTooltip="% Yield (Residual) must be within range 0 - 100 %  with 2 decimals"
                    [matTooltipDisabled]="form.get('tighteningSpecification').value != 'PercentageYieldResidual'"
                    [ngClass]="form.get('tighteningSpecOveride').valid ? '' : 'highLight'"
                    [class.select-disable]="enable"
                />
            </ng-container>
        </div>
    </div>
</div>
